import React from "react";
import { graphql } from '@apollo/client/react/hoc';
import { gql } from "@apollo/client";
import { Loading } from "@website2018/da-dobsonville";
import { Route, Switch, Redirect } from "react-router-dom";

import MetaHeader from '../../components/Meta/MetaHeader';
import PeopleTemplate from '../../components/People/PeopleTemplate';

const PeopleRouter = props => {
  return (
    <Switch>
      <Route exact path="/:parent/:slug" component={PeopleContainer} />
      <Route exact path="/:slug" component={PeopleContainer} />
    </Switch>
  );
};

class PeopleContainer extends React.Component {
  render() {
    const { loading, error, page: p } = this.props;

    if (loading) return <Loading />;
    if (error || !p) return <Redirect to={"/not-found"} />;

    return [<MetaHeader p={p} />, <PeopleTemplate {...this.props} />];
  }
}

const PEOPLE_QUERY = gql`
  query getPeople($slug: String!) {
    page(slug: $slug) {
      id
      slug
      seo
      hero {
        headline
        cta_type
        cta_group {
          title
          link_label
          link_url
        }
        background_image {
          url
        }
        focus_point
      }
      meta {
        people {
          heading
          connected {
            id
            slug
            rawTitle
            title {
              rendered
            }
            excerpt {
              rendered
            }
            role
            facebook
            twitter
            featured_media {
              id
              source_url
              title {
                rendered
              }
              media_details {
                sizes {
                  medium { source_url }
                }
              }
            }
          }
        }
      }
      highlight {
        person {
          id
          slug
          title {
            rendered
          }
          excerpt {
            rendered
          }
          role
          facebook
          twitter
          featured_media {
            id
            source_url
            title {
              rendered
            }
            media_details {
              sizes {
                large { source_url }
              }
            }
          }
        }
      }
      excerpt {
        rendered
      }
      title {
        rendered
      }
      content {
        rendered
      }
      parent {
        slug
        title {
          rendered
        }
        content {
          rendered
        }
        children {
          id
          slug
          title {
            rendered
          }
        }
      }
      children {
        id
        slug
        title {
          rendered
        }
      }
    }
  }
`;

const withPeople = graphql(PEOPLE_QUERY, {
  options: props => {
    return {
      variables: {
        slug: props.match.params.slug
      }
    };
  },
  props: ({ data, post }) => ({ ...data })
});

PeopleContainer = withPeople(PeopleContainer);

export default PeopleRouter;
